import {create} from 'zustand';
import {ChangeSpecialtyStore} from './types';

const useChangeSpecialtyDialogStore = create<ChangeSpecialtyStore>(set => ({
	changeSpecialtyDialog: false,
	setChangeSpecialtyDialog: value => set({changeSpecialtyDialog: value}),
}));

export {useChangeSpecialtyDialogStore};
